import { fetchEventSource } from '@microsoft/fetch-event-source';
import { attempt } from 'es-toolkit';
import { FetchContext } from '../fetch-context';

export type SyncProgressHandler = (progress: number) => void;

interface SyncProgress {
  progress: number;
}

class SyncCompleteError extends Error {}

export const syncEligibility: (
  fetchContext: FetchContext,
  onProgress: SyncProgressHandler,
  accessToken?: string,
  signal?: AbortSignal,
) => Promise<void> = async (fetchContext, onProgress, accessToken, signal) => {
  try {
    await fetchEventSource(`${fetchContext.baseUrl}/api/partners/eligibility/sync`, {
      method: 'POST',
      openWhenHidden: true,
      signal,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'text/event-stream',
      },
      onmessage: (event) => {
        if (!event.data) {
          return;
        }

        const [error, status] = attempt(() => JSON.parse(event.data) as SyncProgress);
        if (!error && status) {
          onProgress(status.progress);
        }
      },
      onclose: () => {
        // The server closes the stream once the sync finishes; stop without reconnecting.
        throw new SyncCompleteError();
      },
      onerror: (error) => {
        // Never retry: this is a POST that triggers the sync, so a reconnect would re-run it.
        throw error;
      },
    });
  } catch (error) {
    if (!(error instanceof SyncCompleteError)) {
      throw error;
    }
  }
};
